import React, {useState } from "react";
import LoaderComponent from '../../ReusableComponents/LoaderComponent';
import mapIcon from "../../assets/marker.png";
import dateFormat from "dateformat";
import Loading from "../../ReusableFunctions/Loader";
import SelectComponent from "../../ReusableComponents/SelectComponent";
import Button from "../RequestsOverView/Button";
import ReschduleRequestPopup from "./MakePaymentPopup";
import MakePaymentPopup from "./MakePaymentPopup";
import { updateIncentiveStatus } from "../../apis/incentives/incentives";
import { BES_INCENTIVE_STATUS } from "../../appConstants";
import copyIcon from "../../assets/copyBlue.svg";
import copyDoneIcon from "../../assets/checkmark.png";

import { useEffect } from "react";

export default function IncentiveDetailsSection({
  localIncentive,
  markAsPaidPopup,
  setMarkAsPaidPopup,
  isLoading,
  incentive,
  setLocalIncentive,
  onIncentiveUpdate,
  onResetStatus,
}) {
  const [isCopyUPI, setIsCopyUPI] = useState(false);

     useEffect(()=>{
      setLocalIncentive(incentive);
     },[incentive])

     const copyUPIId=()=>{
 if (incentive?.bes_upi) {
      const tempTextArea = document.createElement("textarea");
      tempTextArea.value = incentive?.bes_upi;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      try {
        document.execCommand("copy");
        setIsCopyUPI(true);
        setTimeout(() => {
          setIsCopyUPI(false);
        }, 1500);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
      document.body.removeChild(tempTextArea);
    } else {
      console.error("DSP ID is undefined.");
    }
     }

     const SingleField = ({ label, value, isEditable }) => {
    return (
      <div className="flex gap-2  items-center">
        <span className="font-manrope w-[15%] font-[500] text-[14px] custom-lg:text-[14px]  text-[#3B3B3B] mr-1">
          {label} 
        </span>
        <span className="flex font-manrope items-center font-[550] text-[14px]">
          {value}
          {isEditable && (
            <span className="ml-2 text-[#0F5EFF] font-manrope text-[14px] cursor-pointer font-[600] underline  ">
              Change
            </span>
          )}
        </span>
      </div>
    );
  };
  return (
   <>
   <MakePaymentPopup
   open={markAsPaidPopup}
   incentive={incentive}
   onClose={()=>{
    setMarkAsPaidPopup(false);
   }}
   onRequestUpdate={(updatedIncentive)=>{
    onIncentiveUpdate(updatedIncentive)
   }}
   />
   {isLoading ? (
        <div className="w-[75%]">
          <LoaderComponent width={"3%"} height={"3%"} />
        </div>
      ) : (
        <div
          style={{
            fontFamily: "Manrope !important",
          }}
          className="[&>*]:font-inherit [&>*]:text-inherit w-[100%] max-h-full overflow-y-scroll border-r border-r-[#D9D9D9] font-manrope"
        >
          <div className="w-full px-4 py-4 custom-lg:px-10">
            {/* customer details section  */}
            <div className="w-[75%]" >
            <h4 className="font-manrope font-[700] text-[16px] mb-2 text-[#1E1E1E]">
                BES Details{" "}
              </h4> 
            <div className="w-full flex items-start justify-between mb-5 ">
              <div className="flex flex-col gap-[4px]">
                <span className="text-[16px] text-[#1E1E1E] font-[600] font-manrope ">
                 {incentive?.bes_name ||  "-"}
                </span>
                <span className="text-[14px] font-manrope text-[#3B3B3B] font-[500]">
                  Order No. 
                  <span className="text-[#1E1E1E] font-manrope font-[650]">
                    {incentive?.order_number?`${" "} #${incentive?.order_number}` :"-"}
                  </span>
                </span>
                <div className="flex items-center gap-2" >
                 <span className="text-[14px] font-manrope text-[#0F5EFF] font-[500]">
                  {incentive?.bes_upi ?` BES UPI ID:${" "}${incentive?.bes_upi}`:"-"} 
                </span>
                <img 
                style={{marginTop:"2px",cursor:'pointer'}} 
                src={isCopyUPI?copyDoneIcon:copyIcon} alt="upi copy " 
                width={17} 
                height={17}
                onClick={copyUPIId}
                />
                </div>
              </div>
              <span className="text-[14px] font-manrope text-[#3B3B3B] font-[500">
                Contact No.{" "}
                <span className="font-[600] #3B3B3B">
                  {incentive?.bes_phone?`${incentive?.bes_phone}`:"-"}</span>{" "}
              </span>
            </div>
            </div>
            <div className=" h-[5px]  border-b border-b-[#BFC8D9]"></div>
            {/* service details  */}
            <div className="py-3">
              <h4 className="font-manrope font-[700] text-[16px] text-[#1E1E1E]">
                Order Details{" "}
              </h4>
              <div className="flex flex-col gap-2  w-[100%] my-3">
                <SingleField label={"Customer Name"} value={incentive?.farmer_name || "-"} />
                <SingleField
                label={"Address"}
                value={incentive?.field_address || "-"}
              />
               <SingleField label={"Order Complete date"}
                value={
                         incentive?.order_completed_date
                         ? dateFormat(incentive?.order_completed_date, "dd/mm/yyyy")
                         : "-"
               } />
              </div>
            </div>
            <div className=" h-[5px] border-b border-b-[#BFC8D9]"></div>

            {/* BES incentive  */}
            <div className="py-3">
              <h4 className="font-manrope font-[700] text-[16px] text-[#1E1E1E]">
                BES Incentive{" "}
              </h4>
              {incentive?.status===BES_INCENTIVE_STATUS.PENDING ?<>
              <div className="mt-4 rounded-[8px] text-[13px] font-manrope border border-[#E96E31]  px-3 py-[3px] bg-[#E96E31]/10 w-[280px]">
                <span className="font-manrope text-[#E96E31] font-[550]">The incentive will be 10% of total amount.</span>
              </div>
              <div className="w-[400px] mt-2 border rounded-[10px] border-[#3B3B3B]/30" >
                <div className="px-5 pt-5 py-5">
                    <div className="flex justify-between items-center">
                    <p className="text-[#3B3B3B] text-[14px]">Total Amount </p>
                    <span className="text-[#3B3B3B] text-[14px]">{incentive?.service_amount?`₹ ${incentive?.service_amount}`:"-"}</span>
                    </div>
                   <div className=" h-[5px] border-b border-b-[#BFC8D9]"></div>
                    <div className="flex mt-2 justify-between items-center">
                    <p className="text-[#3B3B3B] text-[14px]">Incentive Amount </p>
                    <span className="text-[#3B3B3B] text-[14px]">{incentive?.incentive_amount?`₹ ${incentive?.incentive_amount}`:"-"}</span>
                    </div>

                      <Button
                        variant="filled"
                        handleClick={()=>{
                          setMarkAsPaidPopup(true);
                        }}
                        color={"#0F5EFF"}
                        width={"100%"}
                        style={{
                            marginTop:"20px"
                        }}
                        title={"Mark As Paid"}
                   />
                </div>
                 
              </div>
              </>:
               <div className="w-[400px] mt-2 border rounded-[10px] border-[#3B3B3B]/30" >
                <div className="px-5 pt-5 py-5">
                    <div className="flex justify-between items-center">
                    <p className="text-[#3B3B3B] text-[14px]">Paid Amount </p>
                    <span className="text-[#3B3B3B] text-[14px]">{incentive?.incentive_amount?`₹ ${incentive?.incentive_amount}`:"-"}</span>
                    </div>
                </div>
                 
              </div>
              }
              
            </div>
          </div>
        </div>
      )}
   </>
  )
}
